import {
  POS_MODULE_NAVIGATION_MESSAGE,
  PosModuleNavigationMessage,
} from '@publicisgroupe/p-os-components';
import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ModuleEnum } from 'utils/enums';
import { moduleNameToEnum } from 'utils/helpers';
import { RouteToModule } from 'utils/routes';

interface CockpitWidgetNavigationProps {
  history: any;
  navigateToWidget: (module: ModuleEnum, queryParams?: string) => void;
}

export const CockpitWidgetNavigation = ({
  history,
  navigateToWidget,
}: CockpitWidgetNavigationProps) => {
  const location = useLocation();

  const getTargetPath = (moduleRoute: string, message: PosModuleNavigationMessage) =>
    message.targetPath ? `${moduleRoute}/${message.targetPath}` : moduleRoute;

  const getSearchString = useCallback(
    (message: PosModuleNavigationMessage) => {
      const messageQuery = message.query ?? '';
      if (!location.search) return `?${messageQuery}`;
      return location.search + `&${messageQuery}`;
    },
    [location.search]
  );

  const navigateToPath = useCallback(
    (module: ModuleEnum, message: PosModuleNavigationMessage) => {
      const moduleRoute = RouteToModule(module);
      history.push({
        pathname: getTargetPath(moduleRoute, message),
        search: getSearchString(message),
      });
    },
    [getSearchString, history]
  );

  // change navigation in cockpit and remove this listener
  const handleWidgetNavigationMessage = useCallback(
    (event: MessageEvent<any>) => {
      if (event.data.message === 'Widget Info') {
        // remove Widget Info when every module uses POS_MODULE_NAVIGATION_MESSAGE
        const moduleName = event.data.widget.module as string;
        const queryParams = event.data.widget.queryParams as string;
        const module = moduleNameToEnum(moduleName);

        if (module) navigateToWidget(module, queryParams);
      } else if (event.data.message === POS_MODULE_NAVIGATION_MESSAGE) {
        const message = event.data as PosModuleNavigationMessage;
        const module = moduleNameToEnum(message.targetModule);

        if (module) navigateToPath(module, message);
      }
    },
    [navigateToWidget, navigateToPath]
  );

  useEffect(() => {
    window.addEventListener('message', handleWidgetNavigationMessage, false);
    return () => {
      window.removeEventListener('message', handleWidgetNavigationMessage);
    };
  }, [handleWidgetNavigationMessage]);

  return <></>;
};
